/// <amd-module name="Build/Admin/Common/Sources/AgentQueueSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";
import { getTaskAgentClient, ITaskAgentRestClient } from "DistributedTask/Client/RestClient/TaskAgent";

import { TaskAgentQueueData, TaskAgentQueuesData } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";
import { ResourceTypeNames } from "Build/Admin/Common/Client/Contracts/Generated/Constants";
import { DataProviders } from "Build/Admin/Common/Constants";
import { CheckIssueData, ResourceCheckIssue } from "Checks/Client/Contracts/PipelinesChecks";

export class AgentQueueSource {
    private _client: ITaskAgentRestClient;
    private _pageContext: IVssPageContext;
    private _queuesData: TaskAgentQueuesData | undefined;
    private _queuesDataInitialized: boolean = false;
    private _queueData: TaskAgentQueueData | undefined;
    private _queueDataInitialized: boolean = false;

    constructor(pageContext: IVssPageContext) {
        this._client = getTaskAgentClient(pageContext);
        this._pageContext = pageContext;
    }

    public getCachedAgentQueues(): TaskAgentQueue[] {
        this._initializeAgentQueuesData();
        if (this._queuesData && this._queuesData.taskAgentQueues) {
            return this._queuesData.taskAgentQueues;
        }
        else {
            return [];
        }
    }

    public getCachedSelectedAgentQueue(): TaskAgentQueue | undefined {
        this._initializeAgentQueueData();
        if (this._queueData && this._queueData.selectedAgentQueue) {
            return this._queueData.selectedAgentQueue;
        }
        else {
            return undefined;
        }
    }

    public async addAgentQueue(agentQueue: TaskAgentQueue, projectId: string, authorizeAllPipelines: boolean): Promise<TaskAgentQueue> {
        return this._client.addAgentQueue(agentQueue, projectId, authorizeAllPipelines);
    }

    public async deleteAgentQueue(id: number, projectId: string): Promise<void> {
        return this._client.deleteAgentQueue(id, projectId);
    }

    private _initializeAgentQueuesData(): void {
        if (!this._queuesDataInitialized) {
            const contributionService: IVssContributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
            this._queuesData = contributionService.getData<TaskAgentQueuesData>(DataProviders.Queues);
            this._queuesDataInitialized = true;
        }
    }

    private _initializeAgentQueueData(): void {
        if (!this._queueDataInitialized) {
            const contributionService: IVssContributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
            this._queueData = contributionService.getData<TaskAgentQueueData>(DataProviders.Queue);
            this._queueDataInitialized = true;
        }
    }

    public getCheckIssuesForAgentQueues(agentQueues: TaskAgentQueue[]): Promise<CheckIssueData | undefined> {
        let resourceParams: { [key: string]: string } = {
            "resourceTypeName" : ResourceTypeNames.Queue,
            "resourceIds" : agentQueues.map(resource => resource.id).join(",")
        };

        const contributionService: IVssContributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getDataAsync<CheckIssueData>(DataProviders.CheckIssues, resourceParams);
    }
}
